export default __webpack_public_path__ + "static/media/header.6a31a8de.jpeg";